import { http, createConfig } from 'wagmi'
import { mainnet } from 'wagmi/chains'
import { injected, metaMask, safe, walletConnect } from 'wagmi/connectors'

const projectId = '5cce32de6c9d5cd028b2b9974761bb76'

export const config = createConfig({
  chains: [mainnet],
  connectors: [injected(), walletConnect({ projectId }),], 
  ssr: true,
  transports: {
    // [mainnet.id]: http(),
   [mainnet.id]: http()
  },
})